const TODOS = "all";

const ehNumero = (valor) => typeof valor === "number" && Number.isFinite(valor);

export const selecionados = (valores) =>
  (valores || []).filter((valor) => valor !== TODOS);

export const filtrosDaV2 = ({
  zonas,
  colecoes,
  vendedores,
  modoOuran,
  legacyIdDaColecao,
}) => {
  const filtros = {};
  const zone_id = selecionados(zonas);
  const seller = selecionados(vendedores);
  const categorias = selecionados(colecoes);
  if (zone_id.length) filtros.zone_id = zone_id;
  if (seller.length) filtros.seller = seller;
  if (categorias.length && modoOuran) {
    filtros.category_source = "ouran";
    filtros.category_id = categorias;
  } else if (categorias.length) {
    filtros.collection_legacy_id = categorias
      .map((valor) => legacyIdDaColecao?.[valor])
      .filter((legacyId) => legacyId !== undefined && legacyId !== null);
  }
  return filtros;
};

export const semFiltroDaV2 = (filtros) => Object.keys(filtros).length === 0;

export const cardsDaV2 = ({ receita, derivadas, conversao, rateio }) => {
  const totais = receita?.totals;
  const faturamento = totais?.bruto_vendas;
  const temVenda = ehNumero(faturamento);
  const semZonaPct = rateio?.totals?.sem_zona_pct;
  return {
    faturamento_total: temVenda ? faturamento : 0,
    quantidade_de_vendas: totais?.documentos ?? 0,
    ticket_medio: totais?.ticket_medio ?? 0,
    valor_medio_faturado_item:
      temVenda && totais?.unidades ? faturamento / totais.unidades : 0,
    conversao: conversao?.branches?.[0]?.conversao_pct ?? null,
    faturamento_por_tempo_permanencia:
      derivadas?.branches?.[0]?.faturamento_por_pessoa_minuto ?? null,
    percent_vendas_sem_zona: ehNumero(semZonaPct) ? semZonaPct / 100 : null,
  };
};

export const indisponiveisDaV2 = (cards) =>
  [
    "conversao",
    "faturamento_por_tempo_permanencia",
    "percent_vendas_sem_zona",
  ].filter((chave) => !ehNumero(cards?.[chave]));
